import { CustomFile } from '../../interfaces/custom_file.interface';
import { ClassToEdit } from './class_to_edit.model';
import { v4 as uuidv4 } from 'uuid';

export class ModuleToEdit {
  courseModuleId: string;
  name: string;
  number?: number;
  attachments: Array<any>;
  isLocal: boolean;
  acceptClassFilesLimit: number;
  classes: Array<ClassToEdit>;
  filesToUpload?: Array<CustomFile>;
  hidden: boolean;
  publishDate: Date | null;
  showPromotion: boolean;
  promotionTitle: string;
  promotionDescription: string;
  promotionButtonText: string;
  promotionButtonUrl: string;

  constructor() {
    this.courseModuleId = uuidv4();
    this.name = '';
    this.attachments = [];
    this.isLocal = true;
    this.acceptClassFilesLimit = 10;
    this.filesToUpload = [];
    this.classes = [new ClassToEdit()];
    this.hidden = false;
    this.publishDate = null;
    this.showPromotion = false;
    this.promotionTitle = '';
    this.promotionDescription = '';
    this.promotionButtonText = '';
    this.promotionButtonUrl = '';
  }
}
